import uqnSplit from '../functions/uqnSplit';
export default function check(uqn) {
    let type;
    if (uqn > 999999) {
        type = 5;
        const uqnArray = uqnSplit(uqn);
        if (uqnArray.length != 7) {
            return false;
        }
        let [power, n1, n2, n3, n4, n5, _] = uqnArray;
        if (power < 2) {
            return false;
        }
        let nBase10 = n1 * 10000 + n2 * 1000 + n3 * 100 + n4 * 10 + n5;
        let t1 = Math.floor(nBase10 / 24 / 24);
        let t2 = Math.floor((nBase10 - t1 * 24 * 24) / 24);
        let t3 = nBase10 % 24;
        if (t1 == 0 || t2 == 0 || t3 == 0) {
            return false;
        }
        if ((t1 == t2) || (t1 == t3) || (t2 == t3)) {
            return false;
        }
        if (t1 > 23 || t2 > 23 || t3 > 23) {
            return false;
        }
    }
    else {
        type = Number(uqn.toString()[0]);
        if (type == 0 || type == 5 || type > 6) {
            return false;
        }
        else if (type == 1) {
            if (uqn.toString().length != 4) {
                return false;
            }
            let [_, a, b, sign] = uqnSplit(uqn);
            if (a == 0 && b == 0) {
                return false;
            }
            if (sign > 3) {
                return false;
            }
        }
        else if (type == 2) {
            if (uqn.toString().length != 5) {
                return false;
            }
            let [_, r, theta1, theta2, theta3] = uqnSplit(uqn);
            if (r == 0) {
                return false;
            }
            let theta = theta1 * 100 + theta2 * 10 + theta3;
            if (theta == 0) {
                return false;
            }
            else if (theta > 627) {
                return false;
            }
        }
        else if (type == 3 || type == 4) {
            if (uqn.toString().length != 4) {
                return false;
            }
            let [_, r, n1, n2] = uqnSplit(uqn);
            let n = n1 * 10 + n2;
            if (r == 0) {
                return false;
            }
            if (n > 23 || n == 0 || n % 6 == 1 || n % 6 == 5) {
                return false;
            }
        }
        else { //type == 6
            if (uqn.toString().length != 4) {
                return false;
            }
            let [_, n1, n2, realImag] = uqnSplit(uqn);
            let n = n1 * 10 + n2;
            if (n % 6 == 0 || realImag > 3) {
                return false;
            }
            if (realImag == 3 && n % 4 == 0) {
                return false;
            }
            if (realImag == 2 && n % 8 == 0) {
                return false;
            }
            if (n > 23) {
                return false;
            }
        }
    }
    return true;
}
